import { fetchAPI } from './fetchAPI';

export const signOut = async () => {
  return await fetchAPI('v1/sign-in', {
    method: 'DELETE',
  });
};
